import { DateTime } from 'luxon'

export const CUBK_AUTORECON_LAUNCH_DATE = DateTime.fromISO(
  '2025-06-16T00:00:00.000Z'
)
export const FIRST_ELIGIBLE_CUBK_REPORTING_PERIOD = '2025-01'
